import { isPlatformServer } from '@angular/common';
import { Injectable, PLATFORM_ID, inject } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ScrollService {
  private platformId = inject<string>(PLATFORM_ID);
  private _scroll: Subject<Event> = new BehaviorSubject<Event>(undefined);
  public readonly onScroll: Observable<Event> = this._scroll.asObservable();

  constructor() {
    if (isPlatformServer(this.platformId)) return;
    window.addEventListener('scroll', e => this._scroll.next(e), true);
  }

  public registerScroll() {
    this._scroll.next(undefined);
  }
}
